export const REFERRAL_STATUS_OPTIONS = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "consultation_scheduled", label: "Consultation Scheduled" },
  { value: "signed_up", label: "Signed Up" },
  { value: "closed", label: "Closed" },
];

export function referralStatusValue(status) {
  if (status === "sms_initiated" || status === "sent") return "new";
  if (status === "completed") return "signed_up";
  return REFERRAL_STATUS_OPTIONS.some(option => option.value === status) ? status : "";
}
